import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsOtherNormalLarge = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M39.35 24l-4.88-13.67A.48.48 0 0034 10a.5.5 0 00-.47.34L25 35.05l-6.53-16.73A.5.5 0 0018 18a.5.5 0 00-.47.32l-5.05 13.32-3-7.33A.5.5 0 009 24H4v1h4.67L12 33.19a.59.59 0 00.47.31.5.5 0 00.46-.32l5-13.28 6.53 16.79A.5.5 0 0025 37a.5.5 0 00.46-.34L34 12l4.52 12.66A.49.49 0 0039 25h5v-1z"
  }));
});
SvgSportsOtherNormalLarge.defaultProps = {
  height: 48,
  width: 48
};
SvgSportsOtherNormalLarge.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsOtherNormalLarge;